import AMPHomePage from './components/AMPHomePage';
import AMPHowToPage, {
  METADATA as HOW_TO_PAGE_METADATA,
} from './components/AMPHowToPage';
import AMPToolsPage, {
  METADATA as TOOLS_PAGE_METADATA,
} from './components/AMPToolsPage';
import AMPAboutPage, {
  METADATA as ABOUT_PAGE_METADATA,
} from './components/AMPAboutPage';

import withOnEnter from './withOnEnter';
import { receivePageMetadata } from './pageMetadata';

const AMPPaths = [];

// AMP page CSS is bundled separately
// This is rendered directly from reactRouterMiddleware (via routeEntry);
// in that case the isAmpRoute prop must be true for the navbar to render
// If rendered from App.js (via a user hitting the endpoint), redirect to dashboard
//
function getAMPRoutes(store) {
  return AMPPaths.map(path => {
    switch (path) {
      case '/':
        return {
          path,
          component: AMPHomePage,
          exact: true,
        };
      case '/how-to-start-a-podcast':
        return {
          path,
          component: withOnEnter(
            setMetadata(store, {
              title: HOW_TO_PAGE_METADATA.TITLE,
              description: HOW_TO_PAGE_METADATA.DESCRIPTION,
            }),
            AMPHowToPage
          ),
          exact: true,
        };
      case '/features':
        return {
          path,
          component: withOnEnter(
            setMetadata(store, {
              title: TOOLS_PAGE_METADATA.TITLE,
            }),
            AMPToolsPage
          ),
          exact: true,
        };
      case '/about':
        return {
          path,
          component: withOnEnter(
            setMetadata(store, {
              title: ABOUT_PAGE_METADATA.TITLE,
            }),
            AMPAboutPage
          ),
          exact: true,
        };
      default:
        throw Error(`AMP Route (${path}) doesn't have a react router route.`);
    }
  });
}

function setMetadata(store, overrides = {}) {
  return props => {
    store && store.dispatch(receivePageMetadata(overrides));
  };
}

export { getAMPRoutes, AMPPaths, setMetadata };
